<div class="bookmark-wrap">
	<div *ngFor="let item of bookmarkListByVisib">
		<div class="bookmark-visib">{{item.visib}}</div>
		<div class="bookmark-list">
			<div *ngFor="let bm of item.list" title="{{bm.href}}">
				<a [href]="bm.href" target="_blank">{{bm.name}}</a>
			</div>
		</div>
	</div>
</div>